import gql from "graphql-tag";
import PostReplyFields from "../../fragments/engagement/PostReplyFields";

export default gql`
  mutation EditPostReply($replyId: ObjectID!, $bodyAsJson: JSON!, $bodyAsPlainText: String!) {
    editPostReply(replyId: $replyId, bodyAsJson: $bodyAsJson, bodyAsPlainText: $bodyAsPlainText) {
      ...PostReplyFields
    }
  }

  ${PostReplyFields}
`;
